import React, { useEffect, useRef } from 'react';

import {
  Header,
  Sidebar
} from '../../components';

import {
  Outlet,
  useLocation,
  useNavigate
} from 'react-router-dom';

import {
  //applicationStatuses,
  useIsMobile,
  useShowToast,
  applicationsList,
  businessList,
  pageTitleSubmit
} from '../../recoil';

import { pageNames } from '../../helpers';

import {
  useRecoilState,
  useRecoilValue
} from 'recoil';

import {
  Fonts
} from '../../constants';

import { StaticRoutes } from '../../Router';
import { appStatuses } from '../../constants';

const styles = {
  pageTitle: {
    fontWeight: 700,
    fontSize: '18px',
    textAlign: 'center',
    marginLeft: '-2rem'
  },
  profileMgnt: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    fontFamily: Fonts.Roboto
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%'
  },
  containerLeft: {
    width: '100%',
    maxWidth: 343,
    marginTop: 38,
    height: 'inherit'
  },
  containerRight: {
    width: 'calc(100% - 343px)',
    minWidth: '70%'
  }
};

export const LoanAccount = () => {
  const isMobile = useRecoilValue(useIsMobile);
  const navigate = useNavigate();
  const [pageTitle, setPageTitle] = useRecoilState(pageTitleSubmit);
  const location = useLocation();
  const showToast = useShowToast();
  const appsList = useRecoilValue(applicationsList);
  const businessListDetails = useRecoilValue(businessList);
  const hasShownToast = useRef(false);

  useEffect(() => {
    if (location?.pathname.includes('applications')) {
      setPageTitle({ pageTitle: 'My applications' });
    } else if (location?.pathname.includes('quotes')) {
      setPageTitle({ pageTitle: 'Funding Quote' });
    } else {
      const currentProductId = location?.pathname.split('accounts/')[1];
      appsList.forEach(app => {
        if (app.applicationId === currentProductId) {
          const productName = pageNames[app.productName];
          setPageTitle({ pageTitle: productName });
        }
      });
    }
  }, [location.pathname]);

  useEffect(() => {
    {
      if (!Array.isArray(appsList) || appsList.length === 0) {
        navigate(StaticRoutes.FundingApplicationDetails);
        return;
      }
    }
  }, [location.pathname, appsList]);

  useEffect(() => {
    if (!hasShownToast.current) {
      showToastNotification();
      hasShownToast.current = true;
    }
  }, []);

  const showToastNotification = () => {
    const pathname = location?.pathname ?? '';

    if (!pathname.includes('dashboard') && !pathname.includes('application')) {
      return;
    }

    const filteredAppList = appsList?.filter(app => app?.applicationStatus === appStatuses?.QuoteAvailable);

    if (!filteredAppList?.length) {
      return;
    }

    let businessId = filteredAppList[0].businessId;

    if (filteredAppList.length > 1) {
      const businessMap = new Map(
        businessListDetails?.businesses?.map(biz => [biz.businessId, biz.businessName])
      );
      const mappedAppList = filteredAppList.map(app => {
        return { ...app, businessName: businessMap.get(app.businessId) || '' };
      });
      mappedAppList.sort((a, b) => a.businessName.localeCompare(b.businessName));
      businessId = mappedAppList[0].businessId;
    }

    const toastMessage = 'You have a new quotation.';
    const iconType = 'info';
    const timeout = 'long';
    const link = `/quotes/${businessId}`;
    showToast(toastMessage, iconType, timeout, link, true);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div style={styles.profileMgnt}>
      <Header onBackClick={handleBackClick} shouldShowBackButton={false}>
        {isMobile &&
          <div style={styles.pageTitle}>{pageTitle}</div>
        }
      </Header>
      <div style={styles.contentSection}>
        {isMobile || <div style={styles.containerLeft}>
          <Sidebar />
        </div>}
        <div style={isMobile ? { ...styles.containerRight, width: '100%' } : styles.containerRight}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};